import { getWidth } from "../common";

const distinctValues =
  drupalSettings.omronSearch?.parametricSearch?.distinctValues;
const columns = [2, 4, 5, 6, 7, 15, 16, 17, 18, 19, 8, 11, 13, 9, 10];

export default columns.map((current) => {
  const field = `relay_mosfet_${current}`;
  return {
    field,
    label: field,
    width: getWidth(columns.length),
    ...(field in (distinctValues ?? [])
      ? {
          filter: {
            type: "RangeBar",
            options: distinctValues[field],
          },
        }
      : {}),
    isSortable: false,
    isCSV: true,
  };
});
